// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Finterfaces%2Fsrc%2Fplugin-store.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { validateArray } from '@augloop/validator-common';
export class PluginCatalogValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'PluginCatalog: Expected object, got undefined object for PluginCatalogValidator' };
        }
        return { success: true };
    }
}
export const pluginCatalogValidatorInstance = new PluginCatalogValidator();
export class PluginMetadataValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'PluginMetadata: Expected object, got undefined object for PluginMetadataValidator' };
        }
        if (obj.pluginId === undefined) {
            return { success: false, error: 'PluginMetadata: Required field "pluginId" is missing' };
        }
        else if (typeof obj.pluginId !== 'string') {
            return { success: false, error: 'PluginMetadata: Required field "pluginId" is wrong type' };
        }
        if (obj.version === undefined) {
            return { success: false, error: 'PluginMetadata: Required field "version" is missing' };
        }
        else if (typeof obj.version !== 'string') {
            return { success: false, error: 'PluginMetadata: Required field "version" is wrong type' };
        }
        if (obj.schemaVersion === undefined) {
            return { success: false, error: 'PluginMetadata: Required field "schemaVersion" is missing' };
        }
        else if (typeof obj.schemaVersion !== 'string') {
            return { success: false, error: 'PluginMetadata: Required field "schemaVersion" is wrong type' };
        }
        if (obj.category === undefined) {
            return { success: false, error: 'PluginMetadata: Required field "category" is missing' };
        }
        else if (typeof obj.category !== 'string') {
            return { success: false, error: 'PluginMetadata: Required field "category" is wrong type' };
        }
        if (obj.name === undefined) {
            return { success: false, error: 'PluginMetadata: Required field "name" is missing' };
        }
        else if (typeof obj.name !== 'string') {
            return { success: false, error: 'PluginMetadata: Required field "name" is wrong type' };
        }
        if (obj.description === undefined) {
            return { success: false, error: 'PluginMetadata: Required field "description" is missing' };
        }
        else if (typeof obj.description !== 'string') {
            return { success: false, error: 'PluginMetadata: Required field "description" is wrong type' };
        }
        if (obj.manifest === undefined) {
            return { success: false, error: 'PluginMetadata: Required field "manifest" is missing' };
        }
        else if (typeof obj.manifest !== 'string') {
            return { success: false, error: 'PluginMetadata: Required field "manifest" is wrong type' };
        }
        if ((obj.apiSpec !== undefined) && (typeof obj.apiSpec !== 'string')) {
            return { success: false, error: 'PluginMetadata: Optional field "apiSpec" is wrong type' };
        }
        if ((obj.legalInfoUrl !== undefined) && (typeof obj.legalInfoUrl !== 'string')) {
            return { success: false, error: 'PluginMetadata: Optional field "legalInfoUrl" is wrong type' };
        }
        if ((obj.token !== undefined)) {
            const result = pluginTokenValidatorInstance.validate(obj.token);
            if (!result.success) {
                result.error = "PluginMetadata.token: " + result.error;
                return result;
            }
        }
        if (obj.activationConfigs !== undefined) {
            const result = validateArray(obj.activationConfigs, 1, pluginActivationConfigValidatorInstance, '{PluginActivationConfig}');
            if (!result.success) {
                result.error = "PluginMetadata.activationConfigs: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const pluginMetadataValidatorInstance = new PluginMetadataValidator();
export class PluginActivationConfigValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'PluginActivationConfig: Expected object, got undefined object for PluginActivationConfigValidator' };
        }
        if (obj.appId === undefined) {
            return { success: false, error: 'PluginActivationConfig: Required field "appId" is missing' };
        }
        else if (typeof obj.appId !== 'string') {
            return { success: false, error: 'PluginActivationConfig: Required field "appId" is wrong type' };
        }
        if (obj.source === undefined) {
            return { success: false, error: 'PluginActivationConfig: Required field "source" is missing' };
        }
        else if (typeof obj.source !== 'string') {
            return { success: false, error: 'PluginActivationConfig: Required field "source" is wrong type' };
        }
        if (obj.platform === undefined) {
            return { success: false, error: 'PluginActivationConfig: Required field "platform" is missing' };
        }
        else if (typeof obj.platform !== 'string') {
            return { success: false, error: 'PluginActivationConfig: Required field "platform" is wrong type' };
        }
        if (obj.selectionMode === undefined) {
            return { success: false, error: 'PluginActivationConfig: Required field "selectionMode" is missing' };
        }
        else if (typeof obj.selectionMode !== 'string') {
            return { success: false, error: 'PluginActivationConfig: Required field "selectionMode" is wrong type' };
        }
        return { success: true };
    }
}
export const pluginActivationConfigValidatorInstance = new PluginActivationConfigValidator();
export class PluginTokenValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'PluginToken: Expected object, got undefined object for PluginTokenValidator' };
        }
        if (obj.accessToken === undefined) {
            return { success: false, error: 'PluginToken: Required field "accessToken" is missing' };
        }
        else if (typeof obj.accessToken !== 'string') {
            return { success: false, error: 'PluginToken: Required field "accessToken" is wrong type' };
        }
        if (obj.Expiry === undefined) {
            return { success: false, error: 'PluginToken: Required field "Expiry" is missing' };
        }
        else if (typeof obj.Expiry !== 'string') {
            return { success: false, error: 'PluginToken: Required field "Expiry" is wrong type' };
        }
        return { success: true };
    }
}
export const pluginTokenValidatorInstance = new PluginTokenValidator();
export class PluginStoreResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'PluginStoreResponse: Expected object, got undefined object for PluginStoreResponseValidator' };
        }
        if (obj.result === undefined) {
            return { success: false, error: 'PluginStoreResponse: Required field "result" is missing' };
        }
        else {
            const result = validateArray(obj.result, 1, pluginMetadataValidatorInstance, '{PluginMetadata}');
            if (!result.success) {
                result.error = "PluginStoreResponse.result: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const pluginStoreResponseValidatorInstance = new PluginStoreResponseValidator();
export class PluginInfoValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'PluginInfo: Expected object, got undefined object for PluginInfoValidator' };
        }
        if (obj.id === undefined) {
            return { success: false, error: 'PluginInfo: Required field "id" is missing' };
        }
        else if (typeof obj.id !== 'string') {
            return { success: false, error: 'PluginInfo: Required field "id" is wrong type' };
        }
        if ((obj.version !== undefined) && (typeof obj.version !== 'string')) {
            return { success: false, error: 'PluginInfo: Optional field "version" is wrong type' };
        }
        return { success: true };
    }
}
export const pluginInfoValidatorInstance = new PluginInfoValidator();
//# sourceMappingURL=plugin-store-validator.g.js.map